import { IconButton, SvgClose } from '@loomhq/lens';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import React, { Component } from 'react';
import { createPortal } from 'react-dom';

import { MODAL_CLOSE } from 'constants/hotkeys';

import './styles.less';

const bodyElm = document.querySelector('body');

export default class Modal extends Component {
  modalRef = React.createRef();

  render() {
    const {
      className = '',
      dark,
      renderTitle,
      show = false,
      showClose = true,
    } = this.props;

    if (!show) {
      return null;
    }

    const title = renderTitle && renderTitle();

    return createPortal(
      <div
        className={`lo-modal-container ${className} ${dark ? 'dark' : ''}`}
        onClick={this.handleDismiss}
      >
        <div
          className="lo-modal"
          onClick={this.handleClickContent}
          ref={this.modalRef}
        >
          {showClose && (
            <div className="close" onClick={this.handleDismiss}>
              <IconButton altText="Close" icon={<SvgClose />} />
            </div>
          )}
          {title && <div className="title">{title}</div>}
          {this.props.children || null}
        </div>
      </div>,
      bodyElm
    );
  }

  componentDidUpdate(prevProps) {
    // We lock scrolling to help prevent everything behind the modal
    // from scrolling. Here's an example of this
    // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
    if (prevProps.show && !this.props.show) {
      clearAllBodyScrollLocks();
    }

    if (!prevProps.show && this.props.show) {
      disableBodyScroll(this.modalRef.current);
    }
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleWindowKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleWindowKeyDown);
    clearAllBodyScrollLocks();
  }

  handleDismiss = () => {
    this.props.onDismiss && this.props.onDismiss();
  };

  handleClickContent = event => {
    event.stopPropagation();
  };

  handleWindowKeyDown = event => {
    if (!this.props.show) {
      return;
    }

    if (MODAL_CLOSE.indexOf(event.key) > -1) {
      this.handleDismiss();
    }
  };
}
